// extracted by mini-css-extract-plugin
export default {"hero-container":"home_hero-container__GFKFF","featured-container":"home_featured-container__gqlN6","hero-image":"home_hero-image__5pFWL","footer-btn":"home_footer-btn__te8m9"};